module.exports = __webpack_public_path__ + "static/media/double_arrow_right.5fb984cb.svg";